'use strict';

module.exports = {
  linearSpace: 'linear_space',
  cubicSpace: 'cubic_space',
  horizontalSpace: 'horizontal_space',
  frontalSpace: 'frontal_space',
  productCount: 'product_count',
};
